export default __webpack_public_path__ + "assets/images/8ef11c813a51c8a56c3ee2de174b0872.svg";